import { render, staticRenderFns } from "./VideosField.vue?vue&type=template&id=09e6c676&scoped=true"
import script from "./VideosField.vue?vue&type=script&lang=ts"
export * from "./VideosField.vue?vue&type=script&lang=ts"
import style0 from "./VideosField.vue?vue&type=style&index=0&id=09e6c676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e6c676",
  null
  
)

export default component.exports